<template>
  <el-dialog id="task-crud"
             :title="((this.task) ? 'Edit' : 'Create') + ' Task'"
             @close="close"
             v-loading="loading"
             :element-loading-text="'Saving Task...'"
             :visible.sync="isVisible"
             :width="(isDialogFullscreen) ? '' : '480px'"
             :fullscreen="isDialogFullscreen">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="user-form">
      <el-form-item label="Task Type" required>
        <el-radio-group v-model="taskType" :disabled="!!this.task">
          <el-radio-button label="Individual"></el-radio-button>
          <el-radio-button label="Group"></el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="!form.group_task" label="User" prop="user_id">
        <el-select v-model="form.user_id" filterable clearable placeholder="Type to filter">
          <el-option-group
            v-for="group in userOptions"
            :key="group.label"
            :label="group.label">
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.group_task" label="Task Members" prop="group_users">
        <user-selector v-model="form.group_users" />
      </el-form-item>
      <el-form-item label="Title" prop="title">
        <el-input v-model="form.title" auto-complete="off" />
      </el-form-item>
      <el-form-item label="Project" prop="project_id">
        <el-select v-model="form.project_id" filterable clearable placeholder="Type to filter">
          <el-option-group
            v-for="group in projectOptions"
            :key="group.label"
            :label="group.label">
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-option-group>
        </el-select>
      </el-form-item>
      <el-form-item label="Status" prop="status" v-if="this.task">
        <el-select v-model="form.status" filterable clearable placeholder="Type to filter">
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="isVisible = false">Cancel</el-button>
      <el-button type="primary" @click="submit">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import { taskStatuses } from '../../util/taskStatuses'

  export default {
    name: 'task-crud',
    props: {
      task: null,
      projectId: null,
      userId: null
    },
    data () {
      return {
        isVisible: true,
        loading: false,
        windowWidth: 0,

        taskType: 'Individual',

        form: {
          project_id: null,
          title: '',
          user_id: null,
          status: 0,
          group_task: false,
          group_users: []
        },

        rules: {
          project_id: [
            {required: true, message: 'Project is required', trigger: 'blur'}
          ],
          title: [
            {required: true, message: 'Title is required', trigger: 'blur'}
          ],
          user_id: [
            {required: true, message: 'User is required', trigger: 'blur'}
          ],
          status: [
            {required: true, message: 'Status is required', trigger: 'blur'}
          ],
          group_users: [
            {required: true, message: 'Task Members are required', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      close () {
        this.$emit('close')
      },
      submit () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            // @Note: See watcher 'saving' for the success/error handling of this action
            var object = {
              id: (this.task) ? this.task.id : null,
              title: this.form.title,
              project_id: this.form.project_id,
              status: this.form.status,
              group_task: this.form.group_task
            }

            if (this.form.group_task) {
              object.group_users = this.form.group_users
            } else {
              object.user_id = this.form.user_id
            }

            if (this.task) {
              // A task was passed, update it
              this.$store.dispatch('updateTask', object)
            } else {
              // A task was not past, create a new one
              this.$store.dispatch('createTask', object)
            }
          } else {
            return false
          }
        })
      },

      setTaskDetails () {
        if (this.task) {
          this.form.project_id = this.task.project_id
          this.form.title = this.task.title
          this.form.user_id = this.task.user_id
          this.form.status = this.task.status
          this.form.group_task = this.task.group_task
          this.form.group_users = this.task.group_users

          this.taskType = (this.task.group_task) ? 'Group' : 'Individual'
        } else {
          this.form.project_id = (this.projectId) ? this.projectId : null
          this.form.user_id = (this.userId) ? this.userId : this.currentUser.id
        }
      },
      getWindowWidth () {
        this.windowWidth = document.documentElement.clientWidth
      }
    },
    computed: {
      isDialogFullscreen () {
        return this.windowWidth < 520
      },
      projectOptions () {
        // Group Projects by their Client
        let optionsObj = {}
        Object.keys(this.projects)
          .map((k) => this.projects[k])
          .sort((a, b) => {
            return a.client_name > b.client_name ? 1 : -1
          })
          .map((project) => {
            if (!optionsObj.hasOwnProperty(project.client_name)) {
              optionsObj[project.client_name] = []
            }
            optionsObj[project.client_name].push({
              label: project.name,
              value: project.id
            })
          })

        let options = []

        for (let clientName in optionsObj) {
          options.push({
            label: clientName,
            options: optionsObj[clientName].sort((a, b) => {
              return a.label > b.label ? 1 : -1
            })
          })
        }
        return options
      },

      userOptions () {
        // Group into Inactive and Active users
        let active = []
        let inactive = []

        Object.keys(this.users)
          .map((k) => this.users[k])
          .sort((a, b) => {
            return a.first_name > b.first_name ? 1 : -1
          })
          .map((user) => {
            let targetOptions = user.status === 1 ? active : inactive
            targetOptions.push({
              label: user.first_name + ' ' + user.last_name,
              value: user.id
            })
          })

        return [{
          label: 'Active',
          options: active
        },
        {
          label: 'Inactive',
          options: inactive
        }]
      },

      statusOptions () {
        return taskStatuses.map((status, index) => {
          return {
            label: status,
            value: index
          }
        })
      },

      statuses () {
        return taskStatuses
      },
      // Vuex Mappings
      currentUser () {
        return this.$store.state.users.currentUser
      },
      users () {
        return this.$store.state.users.objects
      },
      projects () {
        return this.$store.state.projects.objects
      },
      saving () {
        return this.$store.state.tasks.createInProgress || this.$store.state.tasks.updateInProgress
      },
      affectedTask () {
        if (this.task) {
          return this.$store.state.tasks.updatedObject
        } else {
          return this.$store.state.tasks.createdObject
        }
      }
    },
    created () {
      this.setTaskDetails()
    },
    mounted () {
      // We need all Users and Projects for the dropdowns.. make sure we have everything
      this.$store.dispatch('getUsers')
      this.$store.dispatch('getProjects')
      this.$nextTick(function () {
        window.addEventListener('resize', this.getWindowWidth)
        this.getWindowWidth()
      })
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.getWindowWidth)
    },
    watch: {
      'taskType' () {
        if (this.taskType === 'Group') {
          this.form.group_task = true
        } else {
          this.form.group_task = false
        }
      },
      'saving' () {
        // If the Project store is either POSTing or PUTing, show the loader if the action is in progress
        // otherwise handle the expected result of a save
        if (this.saving) {
          this.loading = true
        } else {
          this.loading = false
          if (!this.affectedTask) {
            // There was an error creating/updaing the project.
            // @TODO: Implement error handling
            console.error('Create/Update Failed. @TODO: Add error handling')
          } else {
            this.$message({
              message: (this.task) ? 'Task updated!' : 'Task created!',
              type: 'success'
            })
            this.isVisible = false
            this.$emit('close', this.affectedTask)
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .el-select {
    width: 100%;
  }
</style>
